import algoliasearch from "algoliasearch/lite";
import tableSearch from "./../shared/tableSearch/tableSearch.vue";

import AuthApi from "../../../services/api/authApi.js";
import BrandApi from "../../../services/api/brandApi";

const AuthApiService = new AuthApi();
const BrandApiService = new BrandApi();

export default {
  components: {
    tableSearch,
  },

  data() {
    return {
      blocked: false,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      query: "",
      isTypingSearchQuery: false,
      searchIndexProducts: null,
      brands: [],
      pagination: {
        page: 1,
        limit: 12,
        totalCount: 0,
      },
    };
  },

  beforeMount() {
    this.$loader.$emit("trigger", true);
    this.searchIndexBrands = this.algoliaClient.initIndex(this.$env.getOrigin() + "_brands_sorted_timestamp");
    this.$route.query.page ? (this.pagination.page = Number(this.$route.query.page)) : (this.pagination.page = 1);
    this.$route.query.keyword ? (this.query = this.$route.query.keyword) : (this.query = "");
    this.getBrands();
  },

  methods: {
    getBrands,
    getBrandsCallback,
    search,
    goToEdit,
    viewBrand,
    redirect,
    inviteBrand,
  },
};

function redirect(id) {
  let routeQuery = {
    page: this.pagination.page,
  };

  if (this.query.length) routeQuery.keyword = this.query;

  if (id) {
    this.$router.push({
      name: "editBrand",
      params: { brandId: id },
      query: routeQuery,
    });
  } else {
    this.$router.push({
      name: "onboarding",
    });
  }
}

function inviteBrand(id) {
  if (this.blocked) {
    return;
  } else {
    this.blocked = true;
  }

  this.$loader.$emit("trigger", true);

  AuthApiService.inviteBrand(id)
    .then((response) => {
      this.$swal("Success", "Brand successfully invited!", "success");
      this.getBrands();
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message, "error");
      }
      {
        this.$logger.notify(error);
      }
    })
    .finally(() => {
      this.blocked = false;
      this.$loader.$emit("trigger", false);
    });
}

function goToEdit(id) {
  const routeQuery = {
    page: this.pagination.page,
  };

  if (this.query.length) routeQuery.keyword = this.query;

  this.$router.push({
    name: "editBrand",
    params: { brandId: id },
    query: routeQuery,
  });
}

function viewBrand(url) {
  const routeData = this.$router.resolve({
    name: "brand-bio",
    params: { brandUrl: url },
  });
  window.open(routeData.href, "_blank");
}

function search(val) {
  this.pagination.page = 1;
  this.query = val;
  this.getBrands();
}

function getBrands(page) {
  if (page) {
    this.pagination.page = page;
    this.$router.replace({
      name: this.$route.name,
      query: { page: page },
    });
  }

  this.searchIndexBrands.clearCache();
  this.searchIndexBrands.search(
    {
      query: this.query,
      page: this.pagination.page - 1,
      hitsPerPage: this.pagination.limit,
      facets: "*,status,onboarding_code,onboard_complete",
      facetFilters: [["status:APPROVED", "status:REGISTERED"]],
    },
    this.getBrandsCallback
  );
}

async function getBrandsCallback(err, content) {
  let _self = this;

  if (err) {
    _self.$swal("Attention", _self.$utils.formatErrorMessage("brands"));

    return;
  }

  _self.pagination.limit = content.hitsPerPage;
  _self.pagination.totalCount = content.nbHits;

  _self.brands = content.hits;
  try {
    const { brands } = (await BrandApiService.getOnboardingCodes(_self.brands.map((item) => item.id)))?.data;
    if (brands) {
      _self.brands = _self.brands.map((item) => {
        const onboardingCode = brands?.find((codeListItem) => codeListItem.id === item.id)?.onboarding_code;
        return {
          ...item,
          onboardingFormUrl: onboardingCode ? `${window.location.origin}/onboarding?code=${onboardingCode}` : null,
        };
      });
    }
  } catch (error) {
    _self.$logger.notify(new Error(error));
  }

  _self.$forceUpdate();
  this.$loader.$emit("trigger", false);
}
